import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { BookOpen, DollarSign, CheckCircle, Loader2 } from 'lucide-react';

const ProofreaderOverview = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/stats/proofreader`);
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-orange-500" /></div>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Oorsig</h2>
        <p className="text-gray-600">Jou proeflees statistieke</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard icon={<BookOpen />} title="Voltooide Boeke" value={stats?.completed_books || 0} color="from-blue-400 to-blue-600" />
        <StatCard icon={<DollarSign />} title="Totaal Verdien" value={`R${stats?.total_earned || 0}`} color="from-green-400 to-green-600" />
        <StatCard icon={<CheckCircle />} title="Betaal" value={`R${stats?.paid_earnings || 0}`} color="from-emerald-400 to-emerald-600" />
        <StatCard icon={<DollarSign />} title="Hangende Betalings" value={stats?.pending_payments || 0} color="from-orange-400 to-orange-600" />
      </div>
    </div>
  );
};

const StatCard = ({ icon, title, value, color }) => (
  <Card>
    <CardContent className="pt-6">
      <div className="flex items-center gap-4">
        <div className={`w-16 h-16 bg-gradient-to-br ${color} rounded-2xl flex items-center justify-center text-white`}>
          {React.cloneElement(icon, { className: 'h-8 w-8' })}
        </div>
        <div>
          <p className="text-sm text-gray-600">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default ProofreaderOverview;